/**
 * The projects section: two routes and nothing else.
 *
 * This file used to be the whole section - 839 lines holding two tables, two
 * kanbans, six tabs and a modal, which is well past the point where anybody can
 * find the piece they came for (AGENTS.md §4). Everything now lives in a file
 * named after what it does; the entry point kept its name so no caller had to
 * move (`CrmLayout` looks the section up by this import).
 *
 * - `ProjectsList` / `Roadmap`  the register and the board over it
 * - `ProjectDetail`             the frame around one project
 * - `ProjectOverview` / `ProjectTasks` / `Milestones` / `TimeEntries` /
 *   `ProjectInvoices`           one tab each
 * - `tabs.ts`                   which tabs there are, in which order, with which
 *                               icon and which word
 * - `lib.ts` / `status.ts`      the date-to-column derivation and the tones
 */
import { Route, Routes } from "react-router-dom";
import type { StaffUser } from "../../../lib/auth";
import { ProjectDetail } from "./ProjectDetail";
import { ProjectsList } from "./ProjectsList";

// The section door is `manage:crm.projects` (`crm/nav.ts`), so anybody who can
// reach these routes can also write to a project, and nothing here gates a
// second time on that same right.
//
// One action inside it does NOT answer to that key: "invoice time" on the time
// tab creates an INVOICE, which is `manage:crm.sales` - a right a project
// manager can be without, and the API refuses without it. That check therefore
// lives where the button is drawn, and it reads the operator from
// `CrmUserProvider` (`crm/shell/CrmUser.tsx`) rather than from a prop threaded
// through here. Hence the discarded argument: the `SECTIONS` map in `CrmLayout`
// hands every section a `user`, this one has nothing left to do with it.
export function ProjectsSection({ user: _user }: { user: StaffUser }) {
  return (
    <Routes>
      <Route path="/" element={<ProjectsList />} />
      <Route path="/:id" element={<ProjectDetail />} />
    </Routes>
  );
}
